<template>
    <div>
        <div class="row default-padding-top">
            <div class="col-md-4">
                <form-row-static label="Ersteller">
                    <person-box-user :id="entry.creator" class="padding-left-10"/>
                </form-row-static>
            </div>

            <div v-if="entry.clients[0]" class="col-md-4">
                <form-row-static label="Protokollführer">
                    <person-box-user :id="entry.clients[0]" class="padding-left-10"/>
                </form-row-static>
            </div>

            <div class="col-md-4">
                <form-row-static label="Zeitpunkt">
                    <span class="padding-left-10" v-html="entryTimeString"></span>
                </form-row-static>
            </div>

            <div v-if="entry.description" class="col-md-12">
                <form-row-static label="Notizen für Reviewer">
                    <p class="padding-left-10" v-html="entry.description"></p>
                </form-row-static>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import FormRowStatic from '@/components/form/FormRowStatic.vue';
    import PersonBoxUser from '@/components/PersonBoxUser.vue';
    import {getEntryTimeString} from '@/library/modules/calendar/calendar';
    import {computed} from 'vue';

    const props           = defineProps<{
        entry: CalendarEntryData;
    }>();
    
    const entryTimeString = computed<string>(() =>
    {
        return getEntryTimeString(props.entry, false);
    });
</script>